<template>
  <button id="sidebar-toggle" type="button" class="navbar-toggle" @click="toggleMenu()">
    <span class="sr-only">{{ title }}</span>
    <span class="icon-bar"></span>
    <span class="icon-bar"></span>
    <span class="icon-bar"></span>
  </button>
</template>

<script>
export default {
  name: 'hamburger',
  props: {
    title: { type: String, default: 'Toggle navigation' },
  },
  methods: {
    toggleMenu() {
      const searchItemActive = document.querySelector('.main-menu-search section');
      if (searchItemActive) {
        document.querySelector('.main-menu-search section').style.visibility = 'hidden';
      }
      if (window.eventBus) {
        window.eventBus.$emit('sidebar.toggled', true);
      }
    },
  },
};
</script>
